import React from 'react';
import MenuForm from './MenuForm';

const MenuEditForm = ({ onSuccess, initialData = null, isAdmin = true }) => {
  return (
    <MenuForm
      onSuccess={onSuccess}
      initialData={initialData}
      isAdmin={isAdmin}
    />
  );
};

export default MenuEditForm; 